export const dataCategory = [
  { id: 1, name: "Jury Duly", color: "E85B49", desc: "Desc category 1" },
  {
    id: 2,
    name: "Family and Medical Leave",
    color: "6D41CA",
    desc: "Desc category 2"
  },
  { id: 3, name: "Adverse Weather", color: "EA1E63", desc: "Desc category 3" },
  { id: 4, name: "Childbirth", color: "049588", desc: "Desc category 4" },
  { id: 5, name: "Personal Leave", color: "FE9501", desc: "Desc category 5" },
  { id: 6, name: "Business Trip", color: "000000", desc: "Desc category 6" },
  { id: 7, name: "Vacation", color: "F47F15", desc: "Desc category 7" },
  { id: 8, name: "Military Leave", color: "26B116", desc: "Desc category 8" },
  { id: 9, name: "Pregnancy", color: "5277C5", desc: "Desc category 9" }
];
